import { render, staticRenderFns } from "./MaterialInput.vue?vue&type=template&id=4b5453bb&scoped=true&"
import script from "./MaterialInput.vue?vue&type=script&lang=js&"
export * from "./MaterialInput.vue?vue&type=script&lang=js&"
import style0 from "./MaterialInput.vue?vue&type=style&index=0&id=4b5453bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5453bb",
  null
  
)

export default component.exports